import { ReactNode } from 'react';
import styled, { css } from 'styled-components';

interface FilterWrapperProps {
  children?: ReactNode;
}

export const FilterWrapper = styled.div<FilterWrapperProps>`
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5px;
`;

interface ClearIconProps {
  isHidden?: boolean;
  children?: ReactNode;
  onClick?: any;
}

export const ClearIcon = styled.div<ClearIconProps>`
  margin-left: 10px;
  display: flex;
  justify-content: center;
  flex-direction: column;

  ${({ isHidden }) =>
    isHidden &&
    css`
      visibility: hidden;
    `}
`;
